import React, { useState, useEffect } from 'react';
import { organizationService } from '../../services/organizationService';
import { useLanguage } from '../../contexts/LanguageContext';

const OrganizationDetail = ({ org }) => {
    const { t } = useLanguage();
    const [detail, setDetail] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const response = await organizationService.getOrganizationDetail(org.id);
                if (response.success) setDetail(response.data);
            } catch (error) {
                console.error(t('loadUsersError'), error);
            } finally {
                setLoading(false);
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [org.id]);

    if (loading) return <div>{t('loading')}</div>;
    if (!detail) return <div>{t('noOrganizationsFound')}</div>;

    const { organization, members } = detail;

    return (
        <div className="organization-management">
            <div className="page-header">
                <h1>{organization.name}</h1>
                <p>{organization.org_type === 'government' ? t('typeGovernment') : t('typePrivate')} · {organization.status === 'active' ? t('active') : t('inactive')}</p>
            </div>

            <div className="users-stats">
                <div className="stat-card">
                    <div className="stat-value">{organization.seat_count}</div>
                    <div className="stat-label">{t('totalSeats')}</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">{members.filter(m => m.is_active).length}</div>
                    <div className="stat-label">{t('activeUsers')}</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">{organization.billing_period === 'monthly' ? t('monthly') : t('yearly')}</div>
                    <div className="stat-label">{t('billingPeriod')}</div>
                </div>
            </div>

            <div className="users-table-container">
                <div className="table-header">
                    <h2>{t('organizationMembers')}</h2>
                </div>
                <table className="users-table">
                    <thead>
                        <tr>
                            <th>{t('id')}</th><th>{t('email')}</th><th>{t('name')}</th><th>{t('role')}</th><th>{t('status')}</th><th>{t('licenseKey')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {members.map(m => (
                            <tr key={m.id}>
                                <td>{m.id}</td>
                                <td>{m.email}</td>
                                <td>{m.name}</td>
                                <td>{m.org_role === 'org_admin' ? t('roleAdmin') : t('roleMember')}</td>
                                <td>
                                    <span className={`status-toggle ${m.is_active ? 'active' : 'inactive'}`}>
                                        {m.is_active ? t('active') : t('inactive')}
                                    </span>
                                </td>
                                <td>{m.license_key}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default OrganizationDetail;
